export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceName: "アイラ地域サポート",
      serviceLinkedCmsSettings: [
        {
          serviceLinkedCmsId: 2,
          serviceLinkedCmsUuid: "servicelinkedcms002",
          LinkedCmsMstId: 2,
          linkedCmsName: "レストラン予約管理CMS",
          linkedCmsCode: "cms-xxxxxxxxxx-xxxxx",
          linkedCmsUrl: "https://unicorn.cloud/service-xxxxxx",
        },
        {
          serviceLinkedCmsId: 1,
          serviceLinkedCmsUuid: "servicelinkedcms001",
          LinkedCmsMstId: 1,
          linkedCmsName: "バス予約管理CMS",
          linkedCmsCode: "cms-xxxxxxxxxx-xxxxx",
          linkedCmsUrl: "https://unicorn.cloud/service-xxxxxx",
        }
      ]
    }
  }
}